import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../CustomTable";
import CustomButton from "../CustomButton";
import moment from "moment";
import InputWithIcon from "../FormFields/InputWithIcon";
import { icons } from "../../assets/icons";
import DatePicker from "../FormFields/DatePicker";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import useDebounce from "../../hooks/useDebounce";
import { createSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { l1Columns, storeColumns } from "../Columns/Vouchers/AllVouchers";
import DetailsCard from "../DetailsCard";
import { FaChevronRight } from "react-icons/fa";
import { savedVouchersColumns } from "../Columns/Vouchers/SavedVouchers";
import {
  downloadReports,
  getBase64,
  switchLabel,
  toTitleCase,
} from "../../utils/helpers";
import { toast } from "react-toastify";
import PreviewDocModal from "../../pages/cashDeposits/PreviewDocModal";
import { l1PendingColumns } from "../Columns/Vouchers/PendingVouchers";
import { l1ApprovedColumns } from "../Columns/Vouchers/ApprovedVouchers";
import { l1RejectedColumns } from "../Columns/Vouchers/RejectedVouchers";
import RejectModal from "../../CustomRejectModal/RejectModal";
import EditApproveModal from "../../CustomEditApproveModal/EditApproveModal";
import SendBackForReworkModal from "../../CustomSendBackForReworkModal/SendBackForReworkModal";
import {
  downloadReportsFun,
  getArrayOfSelectedStoresCode,
} from "../../../srcWeb/utils/helpers";
import {
  normalizeVoucherParentRowForStoreColumns,
  resolveVoucherListRowId,
  storeVoucherParentsFromGetRecordsResponse,
} from "../../../srcWeb/utils/dmsStandaloneListUtils";

const AllVouchers = ({ status }) => {
  const { data, nonProcessedData = {}, apiCall } = useApi();
  const { data: fileStoreData, apiCall: fileDownloadAtStore } = useApi();
  const { apiCall: fileSingleDownload } = useApi();
  const { apiCall: fileDownload } = useApi();
  const { apiCall: DeleteVoucher } = useApi();
  const { apiCall: sendForApproval } = useApi();
  const { apiCall: voucherStatusApi } = useApi();
  const [startDate, setStartDate] = useState(
    moment().subtract({ days: 7 }).toDate()
  );
  const [endDate, setEndDate] = useState(new Date());
  const [tableData, setTableData] = useState();
  const navigate = useNavigate();
  const {
    user: { userLabel = "Store", username },
    selectedStores,
    storeDropdownState,
  } = useAuth();

  const { storeCode = "" } =
    selectedStores?.storeDetails || selectedStores?.[0] || {};

  const storeListRowsFromApi = (payload) => {
    if (!payload) return [];
    if (Array.isArray(payload)) {
      return payload.map(normalizeVoucherParentRowForStoreColumns);
    }
    return storeVoucherParentsFromGetRecordsResponse(payload);
  };

  const storeFetchDependencyKey = useMemo(() => {
    const selectedCode =
      selectedStores?.storeDetails?.storeCode ||
      selectedStores?.storeCode ||
      selectedStores?.value ||
      "";
    const dropdownCount = Array.isArray(storeDropdownState)
      ? storeDropdownState.length
      : storeDropdownState
        ? 1
        : 0;
    return `${selectedCode}|${dropdownCount}`;
  }, [
    selectedStores?.storeDetails?.storeCode,
    selectedStores?.storeCode,
    selectedStores?.value,
    Array.isArray(storeDropdownState) ? storeDropdownState.length : 0,
  ]);

  const [downloadPreviewOpenWithData, setDownloadPreviewOpenWithData] =
    useState(false);
  const [isRejectVisible, setIsRejectVisible] = useState(false);
  const [isEditApproveVisible, setIsEditApproveVisible] = useState(false);
  const [isSendBackForReworkVisible, setIsSendBackForReworkVisible] = useState({
    isOpen: false,
    data: [],
  });

  const userActiveLevel = userLabel;
  const voucherApiCall = (start, end) => {
    navigate(
      {
        pathname: window.location.pathname,
        search: createSearchParams({
          startDate: start,
          endDate: end,
        }).toString(),
      },
      { replace: true }
    );
    setTableData(null);
    // if(storeCode.length > 0){
    apiCall({
      url: apiUrls.dmsService.getRecords,
      dataToSend: {
        startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
        metadataSchemaId: 4,
        endDate: moment(end || start)
          .endOf("d")
          .format("YYYY-MM-DD HH:mm:ss"),
        searchText: "",
        status: status ? status : null,
        storeCodes: getArrayOfSelectedStoresCode(
          selectedStores,
          storeDropdownState
        ),
        // storeCodes: selectedStores?.storeDetails?.storeCode
        //   // ? [selectedStores?.storeDetails?.storeCode]
        //   ? selectedStores?.storeDetails?.storeCode !== "All" ? [selectedStores?.storeDetails?.storeCode] : null
        //   : userLabel == "Store" ? null : [storeCode],
      },
      method: "post",
      ...(userLabel === "Store" && status !== "SAVED"
        ? {
            processData: true,
            accessor: "storeGetResponse",
            itemAccessor: "dataModalRecordsResponse",
          }
        : {}),
    });
    // }
  };

  useEffect(() => {
    voucherApiCall(startDate, endDate);
  }, [storeFetchDependencyKey, status]);

  useEffect(() => {
    if (userLabel !== "Store" || status === "SAVED") return;
    setTableData(storeListRowsFromApi(data));
  }, [data, userLabel, status]);

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end) voucherApiCall(start, end);
  };

  const onClickChangeData = (data) => {
    setTableData(data);
  };

  const onClickDownloadFile = (file_id, filename) => {
    fileDownload({
      url: apiUrls.dmsService.getFile + "/" + file_id,
      method: "get",
      responseType: "blob",
      onSuccess: (apiData) => {
        const url = window.URL.createObjectURL(new Blob([apiData.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      },
    });
  };

  const deleteVoucher = (voucher_id) => {
    DeleteVoucher({
      url: apiUrls.dmsService.deleteVoucher + "/" + voucher_id,
      method: "delete",
      onSuccess: () => {
        toast.success("Successfully Delete Voucher");
        voucherApiCall(startDate, endDate);
      },
    });
  };

  const onClickViewFile = (file_id, filename) => {
    fileDownload({
      url: apiUrls.dmsService.getFile + "/" + file_id,
      method: "get",
      responseType: "blob",
      onSuccess: (apiData) => {
        setDownloadPreviewOpenWithData({
          file: apiData.data,
          filename,
          isOpen: true,
          file_id: file_id,
        });
      },
    });
  };

  const voucherStatusApiCall = (payload, status) => {
    voucherStatusApi({
      url: apiUrls.dmsService.approveRequest,
      dataToSend: payload,
      method: "post",
      onSuccess: () => {
        toast.success(status);
        voucherApiCall(startDate, endDate);
        setIsEditApproveVisible(false);
        setIsRejectVisible(false);
        setIsSendBackForReworkVisible({ isOpen: false });
      },
    });
  };

  const getIds = (rowData) => {
    const ids = [];
    const totalAmount = rowData?.amount || "";
    if (rowData.documents) {
      rowData.documents.forEach((row) => {
        row.pendingDocs.forEach((row) => {
          row?.document.forEach((row) => {
            ids.push({
              id: row?.id,
              approvedAmount: row?.dataModalAttributeSet?.find(
                (item) =>
                  item.metadataTechnicalName == switchLabel(userActiveLevel)
              )?.attributeValue,
              previousAm: row?.dataModalAttributeSet?.find(
                (item) =>
                  item.metadataTechnicalName == switchLabel(userActiveLevel)
              )?.attributeValue,
              totalAmount: totalAmount,
            });
          });
        });
      });
    }

    if (rowData?.pendingDocs) {
      rowData?.pendingDocs.forEach((row) => {
        ids.push({
          id: row?.id,
          approvedAmount: row?.dataModalAttributeSet?.find(
            (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
          )?.attributeValue,
          previousAm: row?.dataModalAttributeSet?.find(
            (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
          )?.attributeValue,
          totalAmount: totalAmount,
        });
      });
    }
    return ids;
  };

  const getIdsForApproval = (rowData) => {
    const totalAmount = rowData?.amount || "";
    const ids = [];
    if (rowData.documents) {
      console.log("rowData --->++[][]", rowData);
      rowData.documents.forEach((row) => {
        row.pendingDocs.forEach((row) => {
          row?.document.forEach((row) => {
            ids.push({
              id: row?.id,
              approvedAmount: row?.dataModalAttributeSet?.find(
                (item) =>
                  item.metadataTechnicalName == switchLabel(userActiveLevel)
              )?.attributeValue,
              previousAm: row?.dataModalAttributeSet?.find(
                (item) =>
                  item.metadataTechnicalName == switchLabel(userActiveLevel)
              )?.attributeValue,
              totalAmount: totalAmount,
            });
          });
        });
      });
    }

    if (rowData?.pendingDocs) {
      console.log("rowData --->++()()", rowData);
      rowData?.pendingDocs.forEach((row) => {
        // row?.document.forEach((row) => {
        ids.push({
          id: row?.id,
          approvedAmount: row?.dataModalAttributeSet?.find(
            (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
          )?.attributeValue,
          previousAm: row?.dataModalAttributeSet?.find(
            (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
          )?.attributeValue,
          totalAmount: totalAmount,
        });
        // });
      });
    }
    return ids;
  };

  const approveRequestHandler = (ids = [], comment = "") => {
    console.log("approved request handler");
    let payload = {
      approved: ids?.map((i) => ({
        id: i.id,
        approvedAmount: i.approvedAmount,
      })),
      comment,
      rejected: [],
    };
    console.log(payload, "payload");
    voucherStatusApiCall(payload, "Approved Vouchers Successfully");
  };

  const rejectRequestHandler = (rowData = [], comment = "") => {
    console.log("Reject Request handler");
    let payload = {
      approved: [],
      comment,
      rejected: getIds(rowData).map((i) => i.id),
    };
    // console.log(payload, "payload", getIds(rowData).map(i => i.id));
    voucherStatusApiCall(payload, "Rejected Vouchers Successfully");
  };

  const sendBackForReworkHandler = (rowData = [], comment = "") => {
    const ids = Array.isArray(rowData) ? rowData : getIds([rowData]);
    let payload = {
      approved: [],
      rejected: [],
      reworkRequested: ids.map((i) => i.id || i),
      comment: comment,
    };
    voucherStatusApi({
      url: apiUrls.dmsService.sendBackForRework,
      dataToSend: payload,
      method: "post",
      onSuccess: () => {
        toast.success("Sent Back for Rework Successfully");
        voucherApiCall(startDate, endDate);
        setIsEditApproveVisible(false);
        setIsRejectVisible(false);
        setIsSendBackForReworkVisible({ isOpen: false });
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message || "Failed to send back for rework");
      },
    });
  };

  const isL1 = userLabel === "L1";
  const isL2 = userLabel === "L2";
  const isFinance = userLabel === "Finance";

  const inBetweenColumnsData = isL2
    ? [{ Header: "Approved by L1", accessor: "l1AmountApproved" }]
    : [
        { Header: "Approved by L1", accessor: "l1AmountApproved" },
        { Header: "Approved by L2", accessor: "l2AmountApproved" },
      ];

  const getStoreCodeByName = (storeName) => {
    return (
      [storeDropdownState.find((i) => i.name == storeName)?.storeCode] || ""
    );
  };

  const downloadVoucherAtStoreLevel = (storeArr, status) => {
    const st = `${moment(startDate).format("YYYY-MM-DD")} 00:00:00`;
    const et = `${moment(endDate).format("YYYY-MM-DD")} 23:59:59`;
    fileDownloadAtStore({
      url: `${apiUrls.dmsService.downloadVoucherStoreLevel}`,
      dataToSend: {
        storeCodes: storeArr,
        status: status,
        metadataSchemaId: 4,
        endDate: et,
        startDate: st,
      },
      method: "post",
      responseType: "blob",
      responseData: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if (status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "AllVoucher.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
      },
    });
  };

  const downloadVoucherAtStoreForSaved = () => {
    const st = `${moment(startDate).format("YYYY-MM-DD")} 00:00:00`;
    const et = `${moment(endDate).format("YYYY-MM-DD")} 23:59:59`;
    fileDownloadAtStore({
      url: `${apiUrls.dmsService.downloadVoucherStoreLevel}`,
      dataToSend: {
        storeCodes: [username],
        status: "Saved",
        metadataSchemaId: 4,
        endDate: et,
        startDate: st,
      },
      method: "post",
      responseType: "blob",
      responseData: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if (status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "AllVoucher.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
      },
    });
  };

  const onClickSingleDownFile = (code) => {
    // const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
    // const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
    fileSingleDownload({
      url: `${apiUrls.dmsService.getDownloadVoucherReport}`,
      // dataToSend: code || [],
      dataToSend: {
        voucherIds: code,
        status: "All",
      },
      method: "post",
      responseType: "blob",
      responseData: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if (status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "AllVoucher.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
      },
    });
  };

  const downloadVoucher = (data, status) => {
    console.log("asdfasdf", data);
    if (data?.storeName) {
      let dat = getStoreCodeByName(data.storeName);
      downloadVoucherAtStoreLevel(dat, status);
    } else {
      let code = data.id;
      let vid = data.vid;
      userLabel == "Store"
        ? onClickSingleDownFile([vid])
        : onClickSingleDownFile([code]);
      // onClickDownloadFile()
    }
  };

  const renderColumns = (extraColumns = []) => {
    if (status === "SAVED") {
      return savedVouchersColumns({
        onClickViewFile,
        onClickDownloadFile,
        deleteVoucher,
        downloadVoucherAtStoreForSaved,
      });
    }

    if (userLabel === "Store") {
      return storeColumns({ navigate, downloadVoucher });
    }
    if (!status) {
      return l1Columns({
        onClickViewFile,
        onClickDownloadFile,
        extraColumns,
        downloadVoucher,
        userLabel,
      });
    }
    if (status === "APPROVED") {
      return l1ApprovedColumns({
        extraColumns,
        userLabel,
        onClickViewFile,
        onClickDownloadFile,
        approveRequestHandler,
        rejectRequestHandler,
        downloadVoucher,
      });
    }
    if (status === "PENDING") {
      return l1PendingColumns({
        onClickViewFile,
        onClickDownloadFile,
        approveRequestHandler,
        rejectRequestHandler,
        extraColumns,
        downloadVoucher,
        inBetweenColumns: isL2 || isFinance ? inBetweenColumnsData : [],
      });
    }
    if (status === "REJECTED") {
      return l1RejectedColumns({
        extraColumns,
        onClickViewFile,
        onClickDownloadFile,
        approveRequestHandler,
        rejectRequestHandler,
        downloadVoucher,
      });
    }
  };

  const amountToTotal = (val) => {
    return val === "amount" ? "total_amount" : val;
  };

  const onClickSendForApprove = async () => {
    const parents = storeListRowsFromApi(nonProcessedData);
    const voucherDetails =
      nonProcessedData?.storeGetResponse?.[0]?.dataModalRecordsResponse ??
      parents[0];
    const values = {
      id: voucherDetails?.id,
      [amountToTotal(
        voucherDetails?.dataModalAttributeSet?.[0]?.metadataTechnicalName
      )]: voucherDetails?.dataModalAttributeSet?.[0]?.attributeValue,
      [amountToTotal(
        voucherDetails?.dataModalAttributeSet?.[1]?.metadataTechnicalName
      )]: voucherDetails?.dataModalAttributeSet?.[1]?.attributeValue,
      documents: (voucherDetails?.documents || []).map((item) => {
        let obj = {};
        item?.dataModalAttributeSet?.forEach((dataSet) => {
          obj[dataSet?.metadataTechnicalName] = {
            value:
              dataSet?.metadataTechnicalName === "date"
                ? moment(dataSet?.attributeValue).toDate()
                : dataSet?.attributeValue,
            id: item?.id,
          };
        });
        obj.id = item?.id;
        if (item?.documentName) {
          obj.documentName = item?.documentName;
        }
        if (item?.documentPath) {
          obj.documentPath = item?.documentPath;
        }
        if (item?.documentPath) {
          obj.file = { value: item?.documentPath };
        }
        return obj;
      }),
    };

    const documents = await Promise.all(
      values?.documents.map(async (item) => {
        let fileData = {};
        if (item?.file?.value?.[0].name) {
          var filename = item?.file?.value[0].name;
          let file = item?.file?.value[0];
          const base64 = await getBase64(file);
          fileData = {
            document: base64.split(",")[1],
            documentName: filename,
          };
        }

        let returnObj = {
          dataModalAttributeSet: Object.keys(item)
            .map((key) => {
              if (
                [
                  "file",
                  "id",
                  "documentName",
                  "documentPath",
                  "approval_status",
                ].includes(key)
              ) {
                return null;
              }
              if (key === "date") {
                let obj = {
                  attributeValue: moment(item?.[key]?.value).format(
                    "YYYY-MM-DD"
                  ),
                  metadataTechnicalName: key,
                };

                if (item?.[key]?.id) {
                  let idd = voucherDetails?.documents
                    ?.find((it) => it?.id === item?.[key]?.id)
                    ?.dataModalAttributeSet?.find(
                      (it) => it?.metadataTechnicalName === key
                    )?.id;
                  if (idd) {
                    obj.id = idd;
                  }
                }

                return obj;
              } else {
                let obj = {
                  attributeValue: item?.[key]?.value,
                  metadataTechnicalName: key,
                };
                if (item?.[key]?.id) {
                  let idd = voucherDetails?.documents
                    ?.find((it) => it?.id === item?.[key]?.id)
                    ?.dataModalAttributeSet?.find(
                      (it) => it?.metadataTechnicalName === key
                    )?.id;

                  if (idd) {
                    obj.id = idd;
                  }
                }

                return obj;
              }
            })
            .filter((it) => it !== null),
          ...fileData,
          metadataSchemaId: 5,
        };

        if (item.id) {
          returnObj.id = item?.id;
        }
        if (item.documentPath) {
          returnObj.documentPath = item?.documentPath;
        }
        if (item.documentName) {
          returnObj.documentName = item?.documentName;
        }

        return returnObj;
      })
    );

    let dataToSend = {
      dataModalAttributeSet: [
        {
          attributeValue: values.description,
          metadataTechnicalName: "description",
          id: voucherDetails?.dataModalAttributeSet?.find(
            (it) => it?.metadataTechnicalName === "description"
          )?.id,
        },
        {
          attributeValue: values.total_amount?.toString(),
          metadataTechnicalName: "amount",
          id: voucherDetails?.dataModalAttributeSet?.find(
            (it) => it?.metadataTechnicalName === "amount"
          )?.id,
        },
      ],
      documents,
      metadataSchemaId: 4,
    };

    if (voucherDetails?.id) {
      dataToSend.id = voucherDetails?.id;
    }
    sendForApproval({
      url: apiUrls.dmsService.sendForApproval,
      dataToSend,
      method: "post",
      onSuccess: () => {
        toast.success("Successfully sent for approval");
        voucherApiCall(startDate, endDate);
      },
    });
  };

  return (
    <div className="flex flex-col py-2">
      <div className="flex flex-col mb-4 gap-y-3 mt-3">
        <DatePicker
          onChange={onChangeDate}
          dateRange
          startDate={startDate}
          endDate={endDate}
        />
      </div>
      <div>
        {/* className="overflow-auto" style={{maxHeight: '63.5vh'}} */}
        <DetailsCard
          showGlobalSearch
          data={
            status === "SAVED"
              ? data?.flatMap((obj) => obj.documents) || data || []
              : tableData
              ? tableData
              : userLabel === "Store"
              ? storeListRowsFromApi(data)
              : data?.storeWiseRecordsResponses || []
          }
          rows={renderColumns(
            tableData
              ? [
                  {
                    Header: "V.ID",
                    accessor: "id",
                    Cell: (rowData) => {
                      const id = resolveVoucherListRowId(rowData);
                      const isPendingDocAvail =
                        status === ""
                          ? true
                          : (status && status !== "PENDING") ||
                            ((!status || status === "PENDING") &&
                              rowData?.pendingDocs?.length);
                      return (
                        <div
                          className={`${
                            isPendingDocAvail
                              ? "underline underline-offset-4 cursor-pointer"
                              : ""
                          }`}
                          style={{
                            color: isPendingDocAvail ? "blue" : "black",
                          }}
                          onClick={() =>
                            isPendingDocAvail &&
                            navigate(`/vouchers/${id}`, {
                              state: {
                                ...rowData,
                                type: status ? toTitleCase(status) : "All",
                              },
                            })
                          }
                        >
                          {id}
                        </div>
                      );
                    },
                  },
                ]
              : [
                  {
                    Header: "Store Name",
                    accessor: "storeName",
                    Cell: (rowData) => {
                      const store_name = rowData?.storeName;
                      return (
                        <div
                          className="cursor-pointer underline underline-offset-4"
                          style={{ color: "blue" }}
                          onClick={() => onClickChangeData(rowData?.documents)}
                        >
                          {store_name}
                        </div>
                      );
                    },
                  },
                ]
          )}
          customRow={(row, rowData) => {
            if (row.Header === "Store Name") {
              return (
                <div
                  className={`min-h-[5rem] bg-[var(--darkGray2)] flex items-center justify-between px-5 text-[var(--whiteColor)] rounded-tl-[1rem] rounded-tr-[1rem]`}
                  onClick={() => {
                    onClickChangeData(rowData?.documents);
                  }}
                >
                  <div className="min-w-[18rem] font-size-medium">
                    {rowData?.[row?.accessor]}
                  </div>

                  <FaChevronRight color="var(--whiteColor)" size={15} />
                </div>
              );
            }

            if (row.Header === "V.ID") {
              let isPendingDocAvail = true;
              if (status !== "") {
                isPendingDocAvail =
                  (status && status !== "PENDING") ||
                  ((!status || status === "PENDING") &&
                    rowData?.pendingDocs?.length);
              }
              const rowVid = resolveVoucherListRowId(rowData);
              return (
                <div
                  className={`min-h-[5rem] bg-[var(--darkGray2)] flex items-center justify-between px-5 text-[var(--whiteColor)] rounded-tl-[1rem] rounded-tr-[1rem]`}
                  onClick={() => {
                    if (userLabel === "Store" || isPendingDocAvail) {
                      navigate(`/vouchers/${rowVid}`, {
                        state: {
                          ...rowData,
                          type: status ? toTitleCase(status) : "All",
                        },
                      });
                    }
                  }}
                >
                  <div className="min-w-[18rem] font-size-medium">
                    {rowVid || rowData?.[row?.accessor]}
                  </div>

                  {userLabel === "Store" || isPendingDocAvail ? (
                    <FaChevronRight color="var(--whiteColor)" size={15} />
                  ) : null}
                </div>
              );
            }
          }}
          sendRowDataInHandler
          isRejectApproveButtonEnable={!status || status === "PENDING"}
          rejectHandler={(rowData) =>
            setIsRejectVisible({ data: rowData, isOpen: true })
          }
          approveHandler={(rowData) => {
            const ids = getIdsForApproval(rowData);
            approveRequestHandler(ids);
          }}
          editApproveHandler={(rowData) => {
            const ids = getIdsForApproval(rowData);
            console.log("-- data", rowData, ids);
            setIsEditApproveVisible({
              isOpen: true,
              data: ids,
              previousAmounts: ids,
            });
          }}
          isVoucher
        />
      </div>

      <div className={`flex justify-between gap-x-4 self-end`}>
        {/* <CustomButton
          title="Download"
          wrapperClassName={`!px-10 mt-5 ${
            data?.length > 0 ? "" : "disabled-kv"
          }`}
          onClick={() => {
            let reportSettings = {
              fileName: "Vouchers", // Name of the resulting spreadsheet
              extraLength: 3, // A bigger number means that columns will be wider
              writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
              writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
              RTL: false, // Display the columns from right-to-left (the default value is false)
            };

            if (
              data?.storeWiseRecordsResponses &&
              (!status || status === "All")
            ) {
              downloadReports(
                [
                  {
                    sheet: "All Vouchers",
                    columns: [
                      {
                        label: "Store Name",
                        value: (row) =>
                          selectedStores?.storeDetails?.name || "All",
                      }, // Top level data
                      {
                        label: "Submitted On",
                        value: (row) => row.submittedOn,
                      }, // Top level data
                      { label: "Amount", value: (row) => row.amount }, // Top level data
                      { label: "Approved", value: (row) => row.approvedAmount }, // Top level data
                      { label: "Pending", value: (row) => row.pendingAmount }, // Top level data
                      { label: "Rejected", value: (row) => row.rejectedAmount }, // Top level data
                    ],
                    content: data?.storeWiseRecordsResponses,
                  },
                ],
                reportSettings
              );
            }
            if (
              data?.storeWiseRecordsResponses &&
              userLabel !== "Store" &&
              status
            ) {
              downloadReports(
                [
                  {
                    sheet: status ? status : "All Vouchers",
                    columns: [
                      {
                        label: "Store Name",
                        value: (row) =>
                          selectedStores?.storeDetails?.name || "All",
                      }, // Top level data
                      {
                        label: "Submitted On",
                        value: (row) => row.submittedOn,
                      }, // Top level data
                      { label: "Amount", value: (row) => row.amount }, // Top level data
                      {
                        label: toTitleCase(status),
                        value: (row) =>
                          status === "APPROVED"
                            ? row.approvedAmount
                            : status === "Pending"
                            ? row.pendingAmount
                            : row?.rejectedAmount,
                      }, // Top level data
                    ],
                    content: data?.storeWiseRecordsResponses,
                  },
                ],
                reportSettings
              );
            }

            if (data?.length > 0 && status !== "SAVED") {
              downloadReports(
                [
                  {
                    sheet: "Vouchers",
                    columns: [
                      {
                        label: "VID",
                        value: (row) =>
                          resolveVoucherListRowId(row) || row.vid || row.id,
                      }, // Top level data
                      {
                        label: "Submitted On",
                        value: (row) => row.submittedOn,
                      }, // Top level data
                      { label: "Amount", value: (row) => row.amount }, // Top level data
                      {
                        label: "L1 Status",
                        value: (row) => row.L1?.status || "-",
                      }, // Top level data
                      {
                        label: "L2 Status",
                        value: (row) => row.L2?.status || "-",
                      }, // Top level data
                      {
                        label: "A/C Status",
                        value: (row) => row.L3?.status || "-",
                      }, // Top level data
                      {
                        label: "Approved Amount",
                        value: (row) => row?.L3?.approvedAmount || "-",
                      }, // Top level data
                    ],
                    content: data,
                  },
                ],
                reportSettings
              );
            }

            if (data?.[0]?.documents?.length > 0 && status === "SAVED") {
              downloadReports(
                [
                  {
                    sheet: "Saved Vouchers",
                    columns: [
                      {
                        label: "Date",
                        value: (row) => row.date,
                      }, // Top level data
                      {
                        label: "Head",
                        value: (row) => row.head,
                      }, // Top level data
                      { label: "Amount", value: (row) => row.amount }, // Top level data
                      {
                        label: "Comment",
                        value: (row) => row?.comment || "-",
                      }, // Top level data
                    ],
                    content: data?.[0]?.documents || [],
                  },
                ],
                reportSettings
              );
            }
          }}
        /> */}

        {/* {alert(JSON.stringify(data?.[0]?.vid), "data?.[0]")} */}

        {status === "SAVED" && (
          // <CustomButton
          //   title="Send for Approval"
          //   wrapperClassName={`!px-10 mt-5 ${
          //     data?.length > 0 ? "" : "disabled-kv"
          //   }`}
          //   onClick={onClickSendForApprove}
          // />
          <CustomButton
            title="Edit Voucher"
            wrapperClassName="!px-10 mt-4"
            onClick={() => {
              navigate("/vouchers/edit", { state: { isEditFeatureOn: true } });
            }}
          />
        )}
      </div>
      <PreviewDocModal
        isModalVisible={downloadPreviewOpenWithData}
        setIsModalVisible={setDownloadPreviewOpenWithData}
      />
      {isRejectVisible.isOpen && (
        <RejectModal
          isModalVisible={isRejectVisible}
          setIsModalVisible={setIsRejectVisible}
          rejectHandler={({ data, comment = "" }) => {
            rejectRequestHandler(data, comment);
          }}
        />
      )}
      {isEditApproveVisible.isOpen && (
        <EditApproveModal
          isModalVisible={isEditApproveVisible}
          setIsModalVisible={setIsEditApproveVisible}
          approveHandler={({ data = [], comment = "" }) => {
            const validIds = [...new Set([...data])];
            approveRequestHandler(validIds, comment);
          }}
          ids={isEditApproveVisible?.previousAmounts}
          totalAmount={isEditApproveVisible?.previousAmounts?.[0]?.totalAmount}
        />
      )}
      {isSendBackForReworkVisible.isOpen && (
        <SendBackForReworkModal
          isModalVisible={isSendBackForReworkVisible}
          setIsModalVisible={setIsSendBackForReworkVisible}
          reworkHandler={({ data, comment = "" }) => {
            sendBackForReworkHandler(data, comment);
          }}
        />
      )}
    </div>
  );
};

export default AllVouchers;
